import type { AIAvatar, AIAvatarVoicePreset } from 'js/src/client';
import StoreORM from 'js/src/data/store-orm';
import { type ImmutableMap } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

export function getAIAvatarVoicePresetsOrm(state: RootState) {
    return new StoreORM<AIAvatarVoicePreset>(state.aiVoicesAndAvatars.aiAvatarVoicePresets);
}

export function getAIAvatarVoicePresetIds(state: RootState): Immutable.List<number> {
    const orm = getAIAvatarVoicePresetsOrm(state);
    return orm.getAllIds();
}

export function getAIAvatarVoicePresetById(
    state: RootState,
    id: number,
): ImmutableMap<AIAvatarVoicePreset> | null {
    const orm = getAIAvatarVoicePresetsOrm(state);
    if (!id || orm.getAllIds().size === 0) {
        return null;
    }
    return orm.getById(id);
}

export function getAIAvatarVoicePresetByAvatarId(
    state: RootState,
    avatarId: number,
): ImmutableMap<AIAvatarVoicePreset> | null {
    const orm = getAIAvatarVoicePresetsOrm(state);
    const ids = orm.getAllIds();
    for (const id of ids.toArray()) {
        const preset = orm.getById(id);
        if (preset.get('avatar_id') === avatarId) {
            return preset;
        }
    }
    return null;
}

export function getAIAvatarsOrm(state: RootState) {
    return new StoreORM<AIAvatar>(state.aiVoicesAndAvatars.aiAvatars);
}

export function getAIAvatarIds(state: RootState) {
    const orm = new StoreORM<AIAvatar>(state.aiVoicesAndAvatars.aiAvatars);
    return orm.getAllIds();
}

export function getAIAvatarById(state: RootState, id: number) {
    const orm = new StoreORM<AIAvatar>(state.aiVoicesAndAvatars.aiAvatars);
    return orm.getById(id);
}

export function getIsAIVoiceoverBatchComplete(state: RootState): boolean {
    return state.aiVoicesAndAvatars.aiVoiceoverBatchComplete;
}
